import * as React from 'react';
import { PropertyListContext } from '../context/PropertyListContext';

export const usePropertyListContext = () => {
  return React.useContext(PropertyListContext);
};
